module.exports = __webpack_public_path__ + "img/arrow-down.2addb154.svg";